module.exports = __webpack_public_path__ + "img/virus-head.1a012b76.png";